import { HttpErrorResponse } from '@angular/common/http';
import { OrderULResponse } from '@cemex-core/cmx-api';
import { createAction, props } from '@ngrx/store';
import { OrderStrategyResponse } from '@ordersnproducts/modules/order-builder/models/order-strategy-response';
import { IOrderData } from '@ordersnproducts/modules/order-confirmation/models/order-confirmation';
import { AdditionalInfoOrderConfirmation } from '@ordersnproducts/modules/multiple-order-online/redux/reducers/orders-forms.reducer';

export const createSimulateOrder = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] create Simulate Order');

export const onlyCreateOrder = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] only create order');

export const clearOrderDraft = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] clear order draft');

export const createSimulateOrderSuccess = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] create Simulate Order Success',
  props<{ payload: OrderULResponse }>(),
);

export const onlyCreateOrderSuccess = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] only create order success',
  props<{ payload: OrderULResponse }>(),
);

export const onlyCreateOrderError = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] only create order error',
  props<{ payload: OrderULResponse }>(),
);

export const createSimulateOrderError = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] create Simulate Order Error',
  props<{ payload: HttpErrorResponse }>(),
);

export const orderConfirmationMo = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order',
  props<{ payload: IOrderData }>(),
);
export const orderConfirmationRequest = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order Request',
  props<{ payload: OrderStrategyResponse }>(),
);

export const createFirstGroup = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order Create First Group Order Request',
  props<{ payload: number }>(),
);
export const updateGroupRequest = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order Update Group Order Request',
  props<{ payload: number }>(),
);
export const validateGroupOrderRequestSuccess = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order Validate Group Order Request Success',
  props<{ payload: any }>(),
);
export const validateGroupOrderRequestError = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order Validate Group Order Request Error',
  props<{ payload: any }>(),
);
export const closeGroupOrderRequest = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order Close Group Order Request',
);
export const closeGroupOrderRequestSuccess = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order Close Group Order Request Success',
  props<{ payload: any }>(),
);
export const setAdditionalInfoOrderCreate = createAction(
  '[MULTIPLE ORDERS] [SCHEDULE-ORDER] order confirmation multiple order set additional info',
  props<{ payload: AdditionalInfoOrderConfirmation }>(),
);
export const OrderScheduleActions = {
  createSimulateOrder,
  onlyCreateOrder,
  createSimulateOrderSuccess,
  onlyCreateOrderSuccess,
  createSimulateOrderError,
  onlyCreateOrderError,
  orderConfirmationMo,
  orderConfirmationRequest,
  createFirstGroup,
  updateGroupRequest,
  validateGroupOrderRequestSuccess,
  validateGroupOrderRequestError,
  closeGroupOrderRequest,
  closeGroupOrderRequestSuccess,
  setAdditionalInfoOrderCreate,
  clearOrderDraft,
};

export default OrderScheduleActions;
